import * as React from "react";
function SvgUsers2Circle(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M41.2 7.2C36.5 2.4 30.2 0 24 0 18 0 11.9 2.3 7.2 6.8 2.3 11.6-.1 18 0 24.2c0 6 2.3 11.9 6.8 16.6 4.7 4.8 11 7.2 17.2 7.2 6 0 12.1-2.3 16.8-6.8 4.2-4.1 6.6-9.4 7.1-14.8.7-6.8-1.6-13.9-6.7-19.2zm4.3 19c-.5 5-2.8 9.8-6.5 13.3-4 4-9.4 6.1-15 6.1-5.9 0-11.4-2.3-15.5-6.5-3.8-4.1-6.1-9.3-6.1-14.9 0-6 2.3-11.5 6.5-15.7 4.1-4 9.5-6.1 15.1-6.1 5.9 0 11.4 2.3 15.5 6.5 4.4 4.7 6.6 10.9 6 17.3zm-11.2-2c1.9-1 3.2-3 3.2-5.3 0-3.2-2.6-6-5.9-6-1.1 0-2 .2-3 .8-1.3-3.1-4.3-5.4-7.9-5.4-4.8 0-8.6 3.8-8.6 8.6 0 3.4 1.8 6.1 4.4 7.6-4.8 1.9-8.3 7-8.3 11.4v1.2h7.2v-2.4H11c.7-4.1 4.9-8.6 9.7-8.6 4.7 0 9 4.6 9.7 8.6h-5.3v2.4h8.4V36c0-3.1-2-6.7-4.8-9.1 1-.5 2-.7 3.5-.7 2.6 0 4.7 2.6 5.4 5h-2.9v2.4h4.8v-1.4c.1-2.8-1.8-6.6-5.2-8zm-2.5-8.8c1.9 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6c-1.3 0-2.6-.7-3.1-1.9.5-1.1.7-2.3.7-3.5v-.6c.6-.9 1.6-1.2 2.4-1.2zM14.6 17c0-3.4 2.8-6.2 6.2-6.2 3.4 0 6.2 2.8 6.2 6.2s-2.8 6.2-6.2 6.2c-3.4 0-6.2-2.8-6.2-6.2zm10.2 7.6c1-.5 1.7-1.1 2.4-1.9.5.6 1.1 1.1 1.7 1.4-1 .2-1.8.7-2.5 1.3-.5-.3-1.1-.6-1.6-.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUsers2Circle);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
